import { render, staticRenderFns } from "./sicknesscategory.vue?vue&type=template&id=573cfea4&"
import script from "./sicknesscategory.vue?vue&type=script&lang=js&"
export * from "./sicknesscategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports